<template>
  <div class="animated fadeIn reg">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <DropdownColumns
              :fields="[]"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <div style="overflow:auto" class="mt-2">
            <b-table
              id="receipts-winnings-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              responsive
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              :no-border-collapse="true"
            >
              <template v-slot:head()="data">
                <div>
                  <div>{{ data.label }}</div>
                  <div class="mt-2 mg">
                    <strong v-if="footer[data.field.key]">
                      {{
                        data.field.key.indexOf("total_won_tickets") > -1
                          ? footer[data.field.key]
                          : round(footer[data.field.key])
                      }}
                    </strong>
                    <span v-else>
                      {{
                        data.field.key.indexOf("total_won_tickets") > -1
                          ? "0"
                          : "0.00"
                      }}
                    </span>
                  </div>
                </div>
              </template>

              <template v-slot:cell(shop_code)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{
                      data.value.name
                    }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(shop_name)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{
                      data.value.name
                    }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(total_stake)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_tax)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_won_tickets)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(total_winnings)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_percent)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:cell(total_stake_0)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_tax_0)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_won_tickets_0)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(total_winnings_0)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_0)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_percent_0)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:cell(total_stake_1)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_tax_1)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_won_tickets_1)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(total_winnings_1)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_1)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_percent_1)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:cell(total_stake_2)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_tax_2)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_won_tickets_2)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(total_winnings_2)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_2)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_percent_2)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:cell(total_stake_3)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_tax_3)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_won_tickets_3)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(total_winnings_3)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_3)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_percent_3)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:cell(total_stake_4)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_tax_4)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_won_tickets_4)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(total_winnings_4)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_4)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_percent_4)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:cell(total_stake_5)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_tax_5)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_won_tickets_5)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(total_winnings_5)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_5)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_percent_5)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:cell(total_stake_6)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_tax_6)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_won_tickets_6)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(total_winnings_6)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_6)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_percent_6)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:cell(total_stake_7)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_tax_7)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_won_tickets_7)="data">
                <span v-if="data.value">{{ data.value }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(total_winnings_7)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_7)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(total_profit_percent_7)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit('bv::refresh::table', 'receipts-winnings-table')
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "receiptsWinnings",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "receiptsWinnings",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: []
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter(item => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter(item => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },
        {
          field: "shop_id",
          multiple: true,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map(elem => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map(elem => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map(elem => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                elem => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter(item => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter(item => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          }
        },
        {
          field: "product_id",
          multiple: true,
          placeholder: "Product",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "products",
          hide_select: true,
          options: [],
          selected: []
        },
        {
          field: "save_time",
          type: "date",
          opens: "right",
          timePicker: false,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documentations for details
            showWeekNumbers: true //show week numbers on each row of the calendar
          },
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          ranges: {
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment()
                .subtract(1, "days")
                .startOf("day"),
              moment()
                .subtract(1, "days")
                .endOf("day")
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek")
            ],
            "Last week": [
              moment()
                .subtract(1, "week")
                .startOf("isoWeek"),
              moment()
                .subtract(1, "week")
                .endOf("isoWeek")
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .subtract(1, "month")
                .endOf("month")
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()]
          }
        }
      ],
      footer: {
        shop_name: "Totals",
        shop_code: "-",
        total_stake: 0,
        total_tax: 0,
        total_winnings: 0,
        total_won_tickets: 0,
        total_profit: 0,
        total_profit_percent: 0
      },
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",
      selected_products: [],

      balancePreviousDay: 0,
      subtotalIn: 0,
      subtotalOut: 0,
      total: 0
    };
  },
  computed: {
    fields() {
      const columns = [
        {
          key: "shop_name",
          label: this.$t("Shop"),
          sortable: false,
          ignore: true,
          class: "stickyColumn1",
          stickyColumn: true
        },
        {
          key: "shop_code",
          label: this.$t("Code"),
          sortable: false,
          ignore: true,
          class: "stickyColumn2",
          stickyColumn: true
        }
      ];

      if (this.selected_products.length) {
        const short = {
          SportsbookSM: "(PS)",
          NewtonSlots: "(SLOT)",
          LiveBetting: "(LIVE)",
          GreyhoundRaces: "(DOGS)",
          Lotto: "(LOTO)",
          LuckySix: "(SIX)",
          Sincro: "(SINC)",
          WinnerSix: "(WSIX)"
        };
        this.selected_products.forEach((elem, index) => {
          let shortName = short[elem.name];
          if (typeof shortName === "undefined") {
            shortName = elem.name;
          }
          columns.push(
            {
              key: "total_stake_" + index,
              label: this.$t("Total Stake") + " " + shortName,
              sortable: false,
              ignore: true,
              class: "text-right"
            },
            {
              key: "total_tax_" + index,
              label: this.$t("Total Tax") + " " + shortName,
              sortable: false,
              ignore: true,
              class: "text-right"
            },
            {
              key: "total_winnings_" + index,
              label: this.$t("Winnings") + " " + shortName,
              sortable: false,
              ignore: true,
              class: "text-right"
            },
            {
              key: "total_won_tickets_" + index,
              label: this.$t("Tickets") + " " + shortName,
              sortable: false,
              ignore: true,
              class: "text-right"
            },
            {
              key: "total_profit_" + index,
              label: this.$t("Profit") + " " + shortName,
              sortable: false,
              ignore: true,
              class: "text-right"
            },
            {
              key: "total_profit_percent_" + index,
              label: this.$t("% Profit") + " " + shortName,
              sortable: false,
              ignore: true,
              class: "text-right"
            }
          );
        });
      }

      const defcolumns = [
        {
          key: "total_stake",
          label: this.$t("Total Stake"),
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "total_tax",
          label: this.$t("Total Tax"),
          sortable: false,
          ignore: true,
          class: "text-right"
        },
        {
          key: "total_winnings",
          label: this.$t("Winnings"),
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "total_won_tickets",
          label: this.$t("Tickets"),
          sortable: true,
          ignore: true,
          class: "text-right"
        },
        {
          key: "total_profit",
          label: this.$t("Profit"),
          sortable: false,
          ignore: true,
          class: "text-right"
        },
        {
          key: "total_profit_percent",
          label: this.$t("% Profit"),
          sortable: false,
          ignore: true,
          class: "text-right"
        }
      ];

      return [...columns, ...defcolumns];
    },
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["receiptsWinnings/endpoint"];

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eshop_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  mounted() {
    this.handleResizeCB = this.handleResize.bind(this);
    window.addEventListener("resize", this.handleResizeCB);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResizeCB);
  },
  methods: {
    handleResize() {
      const firstTds = document.getElementsByClassName("stickyColumn1");
      const secondTds = document.getElementsByClassName("stickyColumn2");

      if (firstTds.length) {
        const firstTd = firstTds[0];
        const elemWidth = firstTd.offsetWidth;

        for (let i = 0; i < secondTds.length; i++) {
          secondTds[i].style.left = `${elemWidth}px`;
        }
      }
    },
    refresh() {
      this.$root.$emit("bv::refresh::table", "receipts-winnings-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();
      this.selected_products = this.filterOptions[4].selected;

      // const companyByID = this.$store.getters["cache/companyByID"];

      // Promise.all([
      // this.$store.dispatch("cache/fetch", "companies").catch(e => e)
      // ]).finally(() => {
      let companiesIDs = {};
      this.$store
        .dispatch("receiptsWinnings/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;
          if (resp.data.big_total) {
            this.footer = { ...this.footer, ...resp.data.big_total };
          }
          resp.data.rows.forEach(item => {
            if (item.ecompany_id) {
              companiesIDs[item.ecompany_id] = true;
            }
          });

          this.$store
            .dispatch("cacheOnDemand/fetch", {
              key: "companies",
              ids: Object.keys(companiesIDs)
            })
            .then(companiesData => {
              resp.data.rows.forEach((item, index) => {
                if (item.eshop_id) {
                  item.shop_name = {
                    to: item.eshop_id,
                    name: item.shop_name
                  };
                  item.shop_code = {
                    to: item.eshop_id,
                    name: item.shop_code
                  };
                }
                if (item.ecompany_id) {
                  const data = companiesData[item.ecompany_id];
                  if (data) {
                    item.ecompany_id = {
                      to: item.ecompany_id,
                      name: data.name
                    };
                  } else {
                    item.ecompany_id = {
                      to: null,
                      name: item.ecompany_id
                    };
                  }
                }
              });
              callback(resp.data.rows);
              this.$nextTick(() => {
                this.handleResize();
              });
            })
            .catch(err => {
              this.$bvToast.toast(
                this.$t(
                  err.details && err.details.length
                    ? err.details[0]
                    : err.message
                ),
                errorConf(this.$t("Error"))
              );
              this.totalRows = 0;
              callback([]);
            })
            .finally(() => {
              loading.close();
            });
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(
              err.details && err.details.length ? err.details[0] : err.message
            ),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });
      // });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = this.specialDate(
              item.selected.startDate,
              true
            );
            paginationData.dateEnd = this.specialDate(
              item.selected.endDate,
              false
            );
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = this.specialDate(
              moment().startOf("day"),
              true
            );
            paginationData.dateEnd = this.specialDate(
              moment().endOf("day"),
              false
            );
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },
    rowClicked(item, index, event) {},
    redirect() {}
  }
};
</script>

<style lang="scss" scoped>
::v-deep #receipts-winnings-table thead tr th {
  white-space: nowrap;
  padding-bottom: 0;
}
::v-deep #receipts-winnings-table th:nth-child(6n + 3) {
  border-left: 2px solid #999;
}
::v-deep #receipts-winnings-table td:nth-child(6n + 3) {
  border-left: 2px solid #999;
}
::v-deep #receipts-winnings-table th:nth-child(3) {
  border-left: 1px solid #f9f9f9;
}
::v-deep #receipts-winnings-table td:nth-child(3) {
  border-left: 1px solid #f9f9f9;
}
::v-deep
  #receipts-winnings-table
  > thead
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position-y: 30% !important;
}
.mg {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
  padding: 0.25rem;
  border-top: 2px solid #ebedf2;
  color: #000 !important;
}

::v-deep
  #receipts-winnings-table
  > thead
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left)
  .mg {
  margin-right: -20px;
}
</style>
